







import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import MemberGroup from '@/views/member/MemberGroup.vue';

@Component({
  components: { AdminIframe, PageTitle, MemberGroup },
})
export default class MemberGroupIframe extends Vue {
  private get remoteSrc() {
    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/member/basic/group?serviceType=PREMIUM';
  }
}
